"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// determines the current price model based on user selected cabins
// used to enforce one type of price model
function userSelectedPriceModelInfo(state, getters) {
    var selectedPriceModels = {
        selectedCount: 0,
    };
    for (var _i = 0, _a = state.basket; _i < _a.length; _i++) {
        var cabin = _a[_i];
        // there can only be one type selected so se can return the first type
        if (getters[cabin + '/cabins/selectedMainCabinCategory']) {
            if (getters[cabin + '/cabins/isPremiumSelected']) {
                selectedPriceModels[cabin] = 'PREMIUM';
                selectedPriceModels['selected'] = 'PREMIUM';
                selectedPriceModels['selectedCount'] = selectedPriceModels['selectedCount'] + 1;
            }
            else if (getters[cabin + '/cabins/isPremiumAISelected']) {
                selectedPriceModels[cabin] = 'PREMIUMAI';
                selectedPriceModels['selected'] = 'PREMIUMAI';
                selectedPriceModels['selectedCount'] = selectedPriceModels['selectedCount'] + 1;
            }
            else if (getters[cabin + '/cabins/isVarioAISelected']) {
                selectedPriceModels[cabin] = 'VARIOAI';
                selectedPriceModels['selected'] = 'VARIOAI';
                selectedPriceModels['selectedCount'] = selectedPriceModels['selectedCount'] + 1;
            }
            else {
                selectedPriceModels[cabin] = getters['general/cruise'].priceModel;
                selectedPriceModels['selected'] = getters['general/cruise'].priceModel;
                selectedPriceModels['selectedCount'] = selectedPriceModels['selectedCount'] + 1;
            }
        }
    }
    return selectedPriceModels;
}
exports.default = userSelectedPriceModelInfo;
//# sourceMappingURL=userSelectedPriceModel.js.map